import React,{useEffect,useRef} from 'react'
import '../gcontador.css';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import Importarcontador from './importarcontador';
import Pesquisarcontador from './pesquisarcontador';
import ListaContador from './ListaContador';

import Gestcontaopc from './Gestcontaopc';
function GestContadores() {
    const ref=useRef([]);
    
    useEffect(()=>{localStorage.setItem('mainheig',ref.current.offsetHeight)},[])
    
    return (
           <Router>
           <div className="Gest-contadores" ref={ref}  >
                   <Gestcontaopc />
                   <div>
                       <Switch>
                           <Route path="/home/gest-contadores/importar-contador" exact component={Importarcontador}/>
                           <Route path="/home/gest-contadores/pesquisar-contador" exact component={Pesquisarcontador}/>
                           <Route path="/home/gest-contadores/listar-contador" exact component={ListaContador}/>
        
                               
                       </Switch>
                   </div>
               
           </div>
           
           </Router>   );
}

export default GestContadores
